export default __webpack_public_path__ + "static/SelectorBackground2024-a525f991c9aeeda2da90fa721accd23f.png";